import type {ImageField, KeyTextField, LinkField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import {Icon} from 'src/common/Icon'
import {LinkWrapper} from 'src/common/LinkWrapper'

type ToolCardV2Props = {
  integration: {
    link: LinkField
    logo: ImageField
    name: KeyTextField
    description: KeyTextField
  }
  index?: number
  pageUid?: string
}

export const ToolCardV2 = ({integration: {link, logo, name, description}, index, pageUid}: ToolCardV2Props) => (
  <LinkWrapper
    mktgId={`integrations-name-${name}`}
    location={`integrations-container-${index}`}
    pageName={pageUid}
    dataType="integration-tool"
    link={link}
    className="group md:col-span-3 md:h-full"
  >
    <div className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-moss-grey-150 bg-moss-white pb-4 md:col-span-3 md:h-full">
      <div className="flex h-[120px] items-center justify-center bg-grey-120">
        <PrismicNextImage
          field={logo}
          className="transition-all duration-300 group-hover:scale-110"
          height={logo.dimensions?.height}
          width={logo.dimensions?.width}
        />
      </div>
      <div className="flex justify-between gap-[10px] pl-[26px] pr-4">
        <div className="flex flex-col gap-1">
          <span className="text-tg-body-l text-moss-black">{name}</span>
          <span className="text-button-s text-moss-grey-400">{description}</span>
        </div>
        {isFilled.link(link) && (
          <div className="relative isolate flex size-8 min-w-8 items-center justify-center self-end rounded-[2.67px]">
            <Icon name="arrow" className="z-10 h-[11px] w-[11px] text-green-dark" />
            <div className="absolute inset-0 rounded-[2.67px] border border-black/[10%] transition-all duration-200 group-hover:bg-green-neon" />
          </div>
        )}
      </div>
    </div>
  </LinkWrapper>
)
